//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PaO',
  data () {
    return {
      form: {
        data1: '',
        data2: ''
      },
      dataList1: [
        {value: '104.2', name: '坐位PaO₂', unit: 'mmHg'},
        {value: '103.5', name: '卧位PaO₂', unit: 'mmHg'}
      ],
      contentDescription: '',
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // po2/fio2
        console.log(form)
        let result = null
        if (form.data1 == '104.2') {
          result = form.data1 - form.data2 * 0.27
        } else {
          result = form.data1 - form.data2 * 0.42
        }
        console.log(result)
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/PaO.vue